// Build-time configuration, read from Vite's import.meta.env (see .env.example).
// Values are baked into the bundle at build time.
//
// The tour-builder talks to TWO deployed REST APIs (both API-key protected):
//   - the ingest API   (VITE_API_BASE / VITE_API_KEY)        — the artifact scan
//     (GET /artifacts?status=all) + tourTags membership writes (PUT /artifacts/{id}).
//   - the tours API    (VITE_TOURS_API_BASE / VITE_TOURS_API_KEY) — durable tour
//     ORDER records (TOUR#<slug> items) via GET/POST/PUT /tours. This is the
//     tour-builder stack's own API (its CORS already allows this subdomain).
// Membership is derived by scanning artifacts' tourTags; ORDER is persisted in
// DynamoDB as the TOUR#<slug> record's `order` array (regenerable from the scan).

function readEnv(key: keyof ImportMetaEnv): string {
  const raw = import.meta.env[key];
  return typeof raw === "string" ? raw.trim() : "";
}

/** Ingest REST API base (artifacts scan + tourTags writes), no trailing slash. */
export const API_BASE = readEnv("VITE_API_BASE").replace(/\/+$/, "");

/** Ingest API-Gateway key, sent as `x-api-key` on every /artifacts request. */
export const API_KEY = readEnv("VITE_API_KEY");

/** Tours REST API base (durable TOUR#<slug> order records), no trailing slash. */
export const TOURS_API_BASE = readEnv("VITE_TOURS_API_BASE").replace(/\/+$/, "");

/** Tours API-Gateway key, sent as `x-api-key` on every /tours request. */
export const TOURS_API_KEY = readEnv("VITE_TOURS_API_KEY");

/** Cognito user pool id (auth; shared with the ingest site). Region inferred from prefix. */
export const COGNITO_USER_POOL_ID = readEnv("VITE_COGNITO_USER_POOL_ID");

/** Cognito app client id (this site's public SPA client). */
export const COGNITO_CLIENT_ID = readEnv("VITE_COGNITO_CLIENT_ID");

/** Public image base URL, WITH a single trailing slash. */
export const IMAGE_BASE_URL = (() => {
  const v = readEnv("VITE_IMAGE_BASE_URL");
  if (!v) return "";
  return v.endsWith("/") ? v : v + "/";
})();

/** Public URL for an S3 image key (e.g. "<ulid>/original.jpg"). */
export function imageUrl(key: string | undefined | null): string | undefined {
  if (!key) return undefined;
  return IMAGE_BASE_URL + key;
}

/** True when all required build-time vars are present. */
export const CONFIG_OK = Boolean(
  API_BASE &&
    API_KEY &&
    TOURS_API_BASE &&
    TOURS_API_KEY &&
    IMAGE_BASE_URL &&
    COGNITO_USER_POOL_ID &&
    COGNITO_CLIENT_ID,
);

/** Human-readable list of any missing config keys, for a startup warning. */
export function missingConfig(): string[] {
  const missing: string[] = [];
  if (!API_BASE) missing.push("VITE_API_BASE");
  if (!API_KEY) missing.push("VITE_API_KEY");
  if (!TOURS_API_BASE) missing.push("VITE_TOURS_API_BASE");
  if (!TOURS_API_KEY) missing.push("VITE_TOURS_API_KEY");
  if (!IMAGE_BASE_URL) missing.push("VITE_IMAGE_BASE_URL");
  if (!COGNITO_USER_POOL_ID) missing.push("VITE_COGNITO_USER_POOL_ID");
  if (!COGNITO_CLIENT_ID) missing.push("VITE_COGNITO_CLIENT_ID");
  return missing;
}
